export const AUTH_FAILURE = 'AUTH_FAILURE';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const AUTH_CLEAR_ERRORS = 'AUTH_CLEAR_ERRORS';
export const MENU_TOGGLE = 'MENU_TOGGLE';

export const CATEGORIES_FETCH_SUCCESS = 'CATEGORIES_FETCH_SUCCESS';
export const CATEGORIES_FETCH_ERROR = 'CATEGORIES_FETCH_ERROR';
export const CATEGORY_FETCH_SUCCESS = 'CATEGORY_FETCH_SUCCESS';
export const CATEGORY_FETCH_ERROR = 'CATEGORY_FETCH_ERROR';
export const CATEGORY_SET_SUCCESS = 'CATEGORY_SET_SUCCESS';
export const CATEGORY_SET_ERROR = 'CATEGORY_SET_ERROR';
export const CATEGORY_DELETE_SUCCESS = 'CATEGORY_DELETE_SUCCESS';
export const CATEGORY_DELETE_ERROR = 'CATEGORY_DELETE_ERROR';
export const CATEGORY_EDIT_SUCCESS = 'CATEGORY_EDIT_SUCCESS';
export const CATEGORY_EDIT_ERROR = 'CATEGORY_EDIT_ERROR';
export const CATEGORIES_CLEAR_ERRORS = 'CATEGORIES_CLEAR_ERRORS';

export const PRODUCTS_FETCH_SUCCESS = 'PRODUCTS_FETCH_SUCCESS';
export const PRODUCTS_FETCH_ERROR = 'PRODUCTS_FETCH_ERROR';
export const PRODUCT_FETCH_SUCCESS = 'PRODUCT_FETCH_SUCCESS';
export const PRODUCT_FETCH_ERROR = 'PRODUCT_FETCH_ERROR';
export const PRODUCT_SET_SUCCESS = 'PRODUCT_SET_SUCCESS';
export const PRODUCT_SET_ERROR = 'PRODUCT_SET_ERROR';
export const PRODUCT_DISABLE_SUCCESS = 'PRODUCT_DISABLE_SUCCESS';
export const PRODUCT_DISABLE_ERROR = 'PRODUCT_DISABLE_ERROR';
export const PRODUCT_DELETE_SUCCESS = 'PRODUCT_DELETE_SUCCESS';
export const PRODUCT_DELETE_ERROR = 'PRODUCT_DELETE_ERROR';
export const PRODUCT_EDIT_SUCCESS = 'PRODUCT_EDIT_SUCCESS';
export const PRODUCT_EDIT_ERROR = 'PRODUCT_EDIT_ERROR';
export const PRODUCTS_CLEAR_ERRORS = 'PRODUCTS_CLEAR_ERRORS';
export const PRODUCT_CATALOGS_FETCH_SUCCESS = 'PRODUCT_CATALOGS_FETCH_SUCCESS';
export const PRODUCT_CATALOGS_FETCH_ERROR = 'PRODUCT_CATALOGS_FETCH_ERROR';

export const CATALOGS_FETCH_SUCCESS = 'CATALOGS_FETCH_SUCCESS';
export const CATALOGS_FETCH_ERROR = 'CATALOGS_FETCH_ERROR';
export const CATALOG_FETCH_SUCCESS = 'CATALOG_FETCH_SUCCESS';
export const CATALOG_FETCH_ERROR = 'CATALOG_FETCH_ERROR';
export const CATALOG_SET_SUCCESS = 'CATALOG_SET_SUCCESS';
export const CATALOG_SET_ERROR = 'CATALOG_SET_ERROR';
export const CATALOG_DISABLE_SUCCESS = 'CATALOG_DISABLE_SUCCESS';
export const CATALOG_DISABLE_ERROR = 'CATALOG_DISABLE_ERROR';
export const CATALOG_DELETE_SUCCESS = 'CATALOG_DELETE_SUCCESS';
export const CATALOG_DELETE_ERROR = 'CATALOG_DELETE_ERROR';
export const CATALOG_EDIT_SUCCESS = 'CATALOG_EDIT_SUCCESS';
export const CATALOG_EDIT_ERROR = 'CATALOG_EDIT_ERROR';
export const CATALOG_ADD_ITEM = 'CATALOG_ADD_ITEM';
export const CATALOG_DELETE_ITEM = 'CATALOG_DELETE_ITEM';
export const CATALOGS_CLEAR_ERRORS = 'CATALOGS_CLEAR_ERRORS';

export const ITEMS_FETCH_SUCCESS = 'ITEMS_FETCH_SUCCESS';
export const ITEMS_FETCH_ERROR = 'ITEMS_FETCH_ERROR';
export const ITEM_FETCH_SUCCESS = 'ITEM_FETCH_SUCCESS';
export const ITEM_FETCH_ERROR = 'ITEM_FETCH_ERROR';
export const ITEM_SET_SUCCESS = 'ITEM_SET_SUCCESS';
export const ITEM_SET_ERROR = 'ITEM_SET_ERROR';
export const ITEM_DELETE_SUCCESS = 'ITEM_DELETE_SUCCESS';
export const ITEM_DELETE_ERROR = 'ITEM_DELETE_ERROR';
export const ITEM_DISABLE_SUCCESS = 'ITEM_DISABLE_SUCCESS';
export const ITEM_DISABLE_ERROR = 'ITEM_DISABLE_ERROR';
export const ITEM_EDIT_SUCCESS = 'ITEM_EDIT_SUCCESS';
export const ITEM_EDIT_ERROR = 'ITEM_EDIT_ERROR';
export const ITEMS_CLEAR_ERRORS = 'ITEMS_CLEAR_ERRORS';
export const ITEM_CATALOGS_FETCH_SUCCESS = 'ITEM_CATALOGS_FETCH_SUCCESS';
export const ITEM_CATALOGS_FETCH_ERROR = 'ITEM_CATALOGS_FETCH_ERROR';

export const PRICELISTS_FETCH_SUCCESS = 'PRICELISTS_FETCH_SUCCESS';
export const PRICELISTS_FETCH_ERROR = 'PRICELISTS_FETCH_ERROR';
export const PRICELIST_FETCH_SUCCESS = 'PRICELIST_FETCH_SUCCESS';
export const PRICELIST_FETCH_ERROR = 'PRICELIST_FETCH_ERROR';
export const PRICELIST_SET_SUCCESS = 'PRICELIST_SET_SUCCESS';
export const PRICELIST_SET_ERROR = 'PRICELIST_SET_ERROR';
export const PRICELIST_DISABLE_SUCCESS = 'PRICELIST_DISABLE_SUCCESS';
export const PRICELIST_DISABLE_ERROR = 'PRICELIST_DISABLE_ERROR';
export const PRICELIST_DELETE_SUCCESS = 'PRICELIST_DELETE_SUCCESS';
export const PRICELIST_DELETE_ERROR = 'PRICELIST_DELETE_ERROR';
export const PRICELIST_EDIT_SUCCESS = 'PRICELIST_EDIT_SUCCESS';
export const PRICELIST_EDIT_ERROR = 'PRICELIST_EDIT_ERROR';
export const PRICELIST_ADD_ITEM = 'PRICELIST_ADD_ITEM';
export const PRICELIST_DELETE_ITEM = 'PRICELIST_DELETE_ITEM';
export const PRICELISTS_CLEAR_ERRORS = 'PRICELISTS_CLEAR_ERRORS';

export const TAXRATES_FETCH_SUCCESS = 'TAXRATES_FETCH_SUCCESS';
export const TAXRATES_FETCH_ERROR = 'TAXRATES_FETCH_ERROR';
export const TAXRATES_STATES_FETCH_SUCCESS = 'TAXRATES_STATES_FETCH_SUCCESS';
export const TAXRATES_STATES_FETCH_ERROR = 'TAXRATES_STATES_FETCH_ERROR';
export const TAXRATE_FETCH_SUCCESS = 'TAXRATE_FETCH_SUCCESS';
export const TAXRATE_FETCH_ERROR = 'TAXRATE_FETCH_ERROR';
export const TAXRATE_SET_SUCCESS = 'TAXRATE_SET_SUCCESS';
export const TAXRATE_SET_ERROR = 'TAXRATE_SET_ERROR';
export const TAXRATE_DELETE_SUCCESS = 'TAXRATE_DELETE_SUCCESS';
export const TAXRATE_DELETE_ERROR = 'TAXRATE_DELETE_ERROR';
export const TAXRATE_EDIT_SUCCESS = 'TAXRATE_EDIT_SUCCESS';
export const TAXRATE_EDIT_ERROR = 'TAXRATE_EDIT_ERROR';
export const TAXRATES_CLEAR_ERRORS = 'TAXRATES_CLEAR_ERRORS';
export const TAXRATE_CLEAR_ERRORS = 'TAXRATE_CLEAR_ERRORS';

export const OPTIONS_FETCH_SUCCESS = 'OPTIONS_FETCH_SUCCESS';
export const OPTIONS_FETCH_ERROR = 'OPTIONS_FETCH_ERROR';
export const OPTION_FETCH_SUCCESS = 'OPTION_FETCH_SUCCESS';
export const OPTION_FETCH_ERROR = 'OPTION_FETCH_ERROR';
export const OPTION_SET_SUCCESS = 'OPTION_SET_SUCCESS';
export const OPTION_SET_ERROR = 'OPTION_SET_ERROR';
export const OPTION_DELETE_SUCCESS = 'OPTION_DELETE_SUCCESS';
export const OPTION_DELETE_ERROR = 'OPTION_DELETE_ERROR';
export const OPTION_EDIT_SUCCESS = 'OPTION_EDIT_SUCCESS';
export const OPTION_EDIT_ERROR = 'OPTION_EDIT_ERROR';
export const OPTIONS_CLEAR_ERRORS = 'OPTIONS_CLEAR_ERRORS';
export const OPTION_CLEAR_ERRORS = 'OPTION_CLEAR_ERRORS';

export const OPTIONGROUPS_FETCH_SUCCESS = 'OPTIONGROUPS_FETCH_SUCCESS';
export const OPTIONGROUPS_FETCH_ERROR = 'OPTIONGROUPS_FETCH_ERROR';
export const OPTIONGROUP_FETCH_SUCCESS = 'OPTIONGROUP_FETCH_SUCCESS';
export const OPTIONGROUP_FETCH_ERROR = 'OPTIONGROUP_FETCH_ERROR';
export const OPTIONGROUP_SET_SUCCESS = 'OPTIONGROUP_SET_SUCCESS';
export const OPTIONGROUP_SET_ERROR = 'OPTIONGROUP_SET_ERROR';
export const OPTIONGROUP_DELETE_SUCCESS = 'OPTIONGROUP_DELETE_SUCCESS';
export const OPTIONGROUP_DELETE_ERROR = 'OPTIONGROUP_DELETE_ERROR';
export const OPTIONGROUP_EDIT_SUCCESS = 'OPTIONGROUP_EDIT_SUCCESS';
export const OPTIONGROUP_EDIT_ERROR = 'OPTIONGROUP_EDIT_ERROR';
export const OPTIONGROUPS_CLEAR_ERRORS = 'OPTIONGROUPS_CLEAR_ERRORS';
export const OPTIONGROUP_CLEAR_ERRORS = 'OPTIONGROUP_CLEAR_ERRORS';

export const ADMINS_FETCH_SUCCESS = 'ADMINS_FETCH_SUCCESS';
export const ADMINS_FETCH_ERROR = 'ADMINS_FETCH_ERROR';
export const ADMIN_FETCH_SUCCESS = 'ADMIN_FETCH_SUCCESS';
export const ADMIN_FETCH_ERROR = 'ADMIN_FETCH_ERROR';
export const ADMIN_SET_SUCCESS = 'ADMIN_SET_SUCCESS';
export const ADMIN_SET_ERROR = 'ADMIN_SET_ERROR';
export const ADMIN_EDIT_SUCCESS = 'ADMIN_EDIT_SUCCESS';
export const ADMIN_EDIT_ERROR = 'ADMIN_EDIT_ERROR';
export const ADMINS_CLEAR_ERRORS = 'ADMINS_CLEAR_ERRORS';
export const ADMIN_DELETE_ERROR = 'ADMIN_DELETE_ERROR';
export const ADMIN_DELETE_SUCCESS = 'ADMIN_DELETE_SUCCESS';

export const LOGS_FETCH_SUCCESS = 'LOGS_FETCH_SUCCESS';
export const LOGS_FETCH_ERROR = 'LOGS_FETCH_ERROR';
export const LOG_FETCH_SUCCESS = 'LOG_FETCH_SUCCESS';
export const LOG_FETCH_ERROR = 'LOG_FETCH_ERROR';
export const LOGS_CLEAR_ERRORS = 'LOGS_CLEAR_ERRORS';

export const SETTINGS_FETCH_SUCCESS = 'SETTINGS_FETCH_SUCCESS';
export const SETTINGS_FETCH_ERROR = 'SETTINGS_FETCH_ERROR';
export const SETTINGS_EDIT_SUCCESS = 'SETTINGS_EDIT_SUCCESS';
export const SETTINGS_EDIT_ERROR = 'SETTINGS_EDIT_ERROR';
export const SETTINGS_CLEAR_ERRORS = 'SETTINGS_CLEAR_ERRORS';

export const GLOBAL_SETTINGS_FETCH_SUCCESS = 'GLOBAL_SETTINGS_FETCH_SUCCESS';
export const GLOBAL_SETTINGS_FETCH_ERROR = 'GLOBAL_SETTINGS_FETCH_ERROR';
export const GLOBAL_SETTINGS_EDIT_SUCCESS = 'GLOBAL_SETTINGS_EDIT_SUCCESS';
export const GLOBAL_SETTINGS_EDIT_ERROR = 'GLOBAL_SETTINGS_EDIT_ERROR';
export const GLOBAL_SETTINGS_CLEAR_ERRORS = 'GLOBAL_SETTINGS_CLEAR_ERRORS';

export const SHIPPING_OPTIONS_EDIT_SUCCESS = 'SHIPPING_OPTIONS_EDIT_SUCCESS';
export const SHIPPING_OPTIONS_EDIT_ERROR = 'SETTINGS_CLEAR_ERRORS';

export const SALESCHANNELS_FETCH_SUCCESS = 'SALESCHANNELS_FETCH_SUCCESS';
export const SALESCHANNELS_FETCH_ERROR = 'SALESCHANNELS_FETCH_ERROR';
export const SALESCHANNEL_FETCH_SUCCESS = 'SALESCHANNEL_FETCH_SUCCESS';
export const SALESCHANNEL_FETCH_ERROR = 'SALESCHANNEL_FETCH_ERROR';
export const SALESCHANNEL_SET_SUCCESS = 'SALESCHANNEL_SET_SUCCESS';
export const SALESCHANNEL_SET_ERROR = 'SALESCHANNEL_SET_ERROR';
export const SALESCHANNEL_DISABLE_SUCCESS = 'SALESCHANNEL_DISABLE_SUCCESS';
export const SALESCHANNEL_DISABLE_ERROR = 'SALESCHANNEL_DISABLE_ERROR';
export const SALESCHANNEL_EDIT_SUCCESS = 'SALESCHANNEL_EDIT_SUCCESS';
export const SALESCHANNEL_EDIT_ERROR = 'SALESCHANNEL_EDIT_ERROR';
export const SALESCHANNELS_CLEAR_ERRORS = 'SALESCHANNELS_CLEAR_ERRORS';
export const SALESCHANNEL_DELETE_ERROR = 'SALESCHANNEL_DELETE_ERROR';
export const SALESCHANNEL_DELETE_SUCCESS = 'SALESCHANNEL_DELETE_SUCCESS';

export const CAMPAIGNS_FETCH_SUCCESS = 'CAMPAIGNS_FETCH_SUCCESS';
export const CAMPAIGNS_FETCH_ERROR = 'CAMPAIGNS_FETCH_ERROR';
export const CAMPAIGN_FETCH_SUCCESS = 'CAMPAIGN_FETCH_SUCCESS';
export const CAMPAIGN_FETCH_ERROR = 'CAMPAIGN_FETCH_ERROR';
export const CAMPAIGN_SET_SUCCESS = 'CAMPAIGN_SET_SUCCESS';
export const CAMPAIGN_SET_ERROR = 'CAMPAIGN_SET_ERROR';
export const CAMPAIGN_EDIT_SUCCESS = 'CAMPAIGN_EDIT_SUCCESS';
export const CAMPAIGN_EDIT_ERROR = 'CAMPAIGN_EDIT_ERROR';
export const CAMPAIGNS_CLEAR_ERRORS = 'CAMPAIGNS_CLEAR_ERRORS';
export const CAMPAIGN_DELETE_ERROR = 'CAMPAIGN_DELETE_ERROR';
export const CAMPAIGN_DELETE_SUCCESS = 'CAMPAIGN_DELETE_SUCCESS';
export const CAMPAIGN_DISABLE_SUCCESS = 'CAMPAIGN_DISABLE_SUCCESS';
export const CAMPAIGN_DISABLE_ERROR = 'CAMPAIGN_DISABLE_ERROR';

export const ORDERS_FETCH_SUCCESS = 'ORDERS_FETCH_SUCCESS';
export const ORDERS_FETCH_ERROR = 'ORDERS_FETCH_ERROR';
export const ORDER_FETCH_SUCCESS = 'ORDER_FETCH_SUCCESS';
export const ORDER_FETCH_ERROR = 'ORDER_FETCH_ERROR';
export const ORDER_SET_SUCCESS = 'ORDER_SET_SUCCESS';
export const ORDER_SET_ERROR = 'ORDER_SET_ERROR';
export const ORDER_EDIT_SUCCESS = 'ORDER_EDIT_SUCCESS';
export const ORDER_EDIT_ERROR = 'ORDER_EDIT_ERROR';
export const ORDERS_CLEAR_ERRORS = 'ORDERS_CLEAR_ERRORS';
export const ORDER_DELETE_ERROR = 'ORDER_DELETE_ERROR';
export const ORDER_DELETE_SUCCESS = 'ORDER_DELETE_SUCCESS';
export const ORDER_DISABLE_SUCCESS = 'ORDER_DISABLE_SUCCESS';
export const ORDER_DISABLE_ERROR = 'ORDER_DISABLE_ERROR';
export const ORDER_SHIPMENT_SUCCESS = 'ORDER_SHIPMENT_SUCCESS';
export const ORDER_SHIPMENT_ERROR = 'ORDER_SHIPMENT_ERROR';
export const ORDER_FULFILLMENT_SET_SUCCESS = 'ORDER_FULFILLMENT_SET_SUCCESS';
export const ORDER_FULFILLMENT_SET_ERROR = 'ORDER_FULFILLMENT_SET_ERROR';
export const ORDER_FETCH_LAST60_SUCCESS = 'ORDER_FETCH_LAST60_SUCCESS';
export const ORDER_FETCH_LAST60_ERROR = 'ORDER_FETCH_LAST60_ERROR';

export const REPORTS_FETCH_SUCCESS = 'REPORTS_FETCH_SUCCESS';
export const EVENTS_FETCH_SUCCESS = 'EVENTS_FETCH_SUCCESS';
export const EVENTS_FETCH_ERROR = 'EVENTS_FETCH_ERROR';
export const EVENT_FETCH_SUCCESS = 'EVENT_FETCH_SUCCESS';
export const EVENT_FETCH_ERROR = 'EVENT_FETCH_ERROR';
export const EVENT_SET_SUCCESS = 'EVENT_SET_SUCCESS';
export const EVENT_SET_ERROR = 'EVENT_SET_ERROR';
export const EVENT_EDIT_SUCCESS = 'EVENT_EDIT_SUCCESS';
export const EVENT_EDIT_ERROR = 'EVENT_EDIT_ERROR';
export const EVENTS_CLEAR_ERRORS = 'EVENTS_CLEAR_ERRORS';
export const EVENT_DELETE_ERROR = 'EVENT_DELETE_ERROR';
export const EVENT_DELETE_SUCCESS = 'EVENT_DELETE_SUCCESS';
export const EVENT_FETCH_LAST60_SUCCESS = 'EVENT_FETCH_LAST60_SUCCESS';
export const EVENT_FETCH_LAST60_ERROR = 'EVENT_FETCH_LAST60_ERROR';

export const DISCOUNTS_FETCH_SUCCESS = 'DISCOUNTS_FETCH_SUCCESS';
export const DISCOUNTS_FETCH_ERROR = 'DISCOUNTS_FETCH_ERROR';
export const DISCOUNT_FETCH_SUCCESS = 'DISCOUNT_FETCH_SUCCESS';
export const DISCOUNT_FETCH_ERROR = 'DISCOUNT_FETCH_ERROR';
export const DISCOUNT_SET_SUCCESS = 'DISCOUNT_SET_SUCCESS';
export const DISCOUNT_SET_ERROR = 'DISCOUNT_SET_ERROR';
export const DISCOUNT_DELETE_SUCCESS = 'DISCOUNT_DELETE_SUCCESS';
export const DISCOUNT_DELETE_ERROR = 'DISCOUNT_DELETE_ERROR';
export const DISCOUNT_EDIT_SUCCESS = 'DISCOUNT_EDIT_SUCCESS';
export const DISCOUNT_EDIT_ERROR = 'DISCOUNT_EDIT_ERROR';
export const DISCOUNTS_CLEAR_ERRORS = 'DISCOUNTS_CLEAR_ERRORS';
export const DISCOUNT_CLEAR_ERRORS = 'DISCOUNT_CLEAR_ERRORS';
export const DISCOUNT_DISABLE_SUCCESS = 'DISCOUNT_DISABLE_SUCCESS';
export const DISCOUNT_DISABLE_ERROR = 'DISCOUNT_DISABLE_ERROR';
export const NAVIGATION_TYPE = 'NAVIGATION_TYPE'

export const PROMOTIONS_FETCH_SUCCESS = 'PROMOTIONS_FETCH_SUCCESS';
export const PROMOTIONS_FETCH_ERROR = 'PROMOTIONS_FETCH_ERROR';
export const PROMOTION_FETCH_SUCCESS = 'PROMOTION_FETCH_SUCCESS';
export const PROMOTION_FETCH_ERROR = 'PROMOTION_FETCH_ERROR';
export const PROMOTION_SET_SUCCESS = 'PROMOTION_SET_SUCCESS';
export const PROMOTION_SET_ERROR = 'PROMOTION_SET_ERROR';
export const PROMOTION_DELETE_SUCCESS = 'PROMOTION_DELETE_SUCCESS';
export const PROMOTION_DELETE_ERROR = 'PROMOTION_DELETE_ERROR';
export const PROMOTION_EDIT_SUCCESS = 'PROMOTION_EDIT_SUCCESS';
export const PROMOTION_EDIT_ERROR = 'PROMOTION_EDIT_ERROR';
export const PROMOTIONS_CLEAR_ERRORS = 'PROMOTIONS_CLEAR_ERRORS';
export const PROMOTION_CLEAR_ERRORS = 'PROMOTION_CLEAR_ERRORS';
export const PROMOTION_DISABLE_SUCCESS = 'PROMOTION_DISABLE_SUCCESS';
export const PROMOTION_DISABLE_ERROR = 'PROMOTION_DISABLE_ERROR';

export const GIFTCARDS_FETCH_SUCCESS = 'GIFTCARDS_FETCH_SUCCESS';
export const GIFTCARDS_FETCH_ERROR = 'GIFTCARDS_FETCH_ERROR';
export const GIFTCARD_FETCH_SUCCESS = 'GIFTCARD_FETCH_SUCCESS';
export const GIFTCARD_FETCH_ERROR = 'GIFTCARD_FETCH_ERROR';
export const GIFTCARD_SET_SUCCESS = 'GIFTCARD_SET_SUCCESS';
export const GIFTCARD_UPDATE_SUCCESS = 'GIFTCARD_UPDATE_SUCCESS';
export const GIFTCARD_UPDATE_ERROR = 'GIFTCARD_UPDATE_ERROR';
export const GIFTCARD_SET_ERROR = 'GIFTCARD_SET_ERROR';
export const GIFTCARD_DELETE_SUCCESS = 'GIFTCARD_DELETE_SUCCESS';
export const GIFTCARD_DELETE_ERROR = 'GIFTCARD_DELETE_ERROR';
export const GIFTCARD_EDIT_SUCCESS = 'GIFTCARD_EDIT_SUCCESS';
export const GIFTCARD_EDIT_ERROR = 'GIFTCARD_EDIT_ERROR';
export const GIFTCARDS_CLEAR_ERRORS = 'GIFTCARDS_CLEAR_ERRORS';
export const GIFTCARD_CLEAR_ERRORS = 'GIFTCARD_CLEAR_ERRORS';
export const GIFTCARD_DISABLE_SUCCESS = 'GIFTCARD_DISABLE_SUCCESS';
export const GIFTCARD_DISABLE_ERROR = 'GIFTCARD_DISABLE_ERROR';
export const GIFTCARD_NEW_SUCCESS = 'GIFTCARD_NEW_SUCCESS';
export const GIFTCARD_NEW_ERROR = 'GIFTCARD_NEW_ERROR';

export const FETCHING_TOPRINT = 'FETCHING_TOPRINT';
export const FETCHING_TOPRINT_ERROR = 'FETCHING_TOPRINT_ERROR';

export const ARTICLES_FETCH_SUCCESS = 'ARTICLES_FETCH_SUCCESS';
export const ARTICLES_FETCH_ERROR = 'ARTICLES_FETCH_ERROR';
export const ARTICLE_SET_SUCCESS = 'ARTICLE_SET_SUCCESS';
export const ARTICLE_SET_ERROR = 'ARTICLE_SET_ERROR';
export const ARTICLE_CLEAR_ERRORS = 'ARTICLE_CLEAR_ERRORS';
export const ARTICLE_FETCH_SUCCESS = 'ARTICLE_FETCH_SUCCESS';
export const ARTICLE_FETCH_ERROR = 'ARTICLE_FETCH_ERROR';
export const ARTICLE_EDIT_SUCCESS = 'ARTICLE_EDIT_SUCCESS';
export const ARTICLE_EDIT_ERROR = 'ARTICLE_EDIT_ERROR';
export const ARTICLE_DELETE_SUCCESS = 'ARTICLE_DELETE_SUCCESS';
export const ARTICLE_DELETE_ERROR = 'ARTICLE_DELETE_ERROR';

export const BOXES_FETCH_SUCCESS = 'BOXES_FETCH_SUCCESS';
export const BOXES_FETCH_ERROR = 'BOXES_FETCH_ERROR';
export const BOX_SET_SUCCESS = 'BOX_SET_SUCCESS';
export const BOX_SET_ERROR = 'BOX_SET_ERROR';
export const BOX_CLEAR_ERRORS = 'BOX_CLEAR_ERRORS';
export const BOX_FETCH_SUCCESS = 'BOX_FETCH_SUCCESS';
export const BOX_FETCH_ERROR = 'BOX_FETCH_ERROR';
export const BOX_EDIT_SUCCESS = 'BOX_EDIT_SUCCESS';
export const BOX_EDIT_ERROR = 'BOX_EDIT_ERROR';
export const BOX_DELETE_SUCCESS = 'BOX_DELETE_SUCCESS';
export const BOX_DELETE_ERROR = 'BOX_DELETE_ERROR';

export const OVERLAYS_FETCH_SUCCESS = 'OVERLAYS_FETCH_SUCCESS';
export const OVERLAYS_FETCH_ERROR = 'OVERLAYS_FETCH_ERROR';
export const OVERLAY_SET_SUCCESS = 'OVERLAY_SET_SUCCESS';
export const OVERLAY_SET_ERROR = 'OVERLAY_SET_ERROR';
export const OVERLAY_CLEAR_ERRORS = 'OVERLAY_CLEAR_ERRORS';
export const OVERLAY_FETCH_SUCCESS = 'OVERLAY_FETCH_SUCCESS';
export const OVERLAY_FETCH_ERROR = 'OVERLAY_FETCH_ERROR';
export const OVERLAY_EDIT_SUCCESS = 'OVERLAY_EDIT_SUCCESS';
export const OVERLAY_EDIT_ERROR = 'OVERLAY_EDIT_ERROR';
export const OVERLAY_DELETE_SUCCESS = 'OVERLAY_DELETE_SUCCESS';
export const OVERLAY_DELETE_ERROR = 'OVERLAY_DELETE_ERROR';



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js